import Image from "next/image"
import { MenuItemProps } from "../Utils/constants";
import { useUserStore } from "@/stores/useUserStore";
import { useEffect, useState } from "react";
import { VoucherItem } from "@/lib/constants";
import axios from "axios";
import { getNewToken } from "@/lib/Definitions";


const MyVouchers = (props: MenuItemProps) => {
  const { userInfo, getUser, updateUser } = useUserStore();
  const [userData, setUserData] = useState(getUser());
  const [voucherList, setVoucherList] = useState<Array<VoucherItem>>([]);
  const [init, setInit] = useState(true);

  useEffect(() => {
    const get_vouchers = async () => {
      try {
        const response = await axios.get(
          "/api/vouchers",
          { headers: { 'Authorization': 'Bearer ' + userData.token } }
        );

        if (response.status === 200) {
          setVoucherList(response.data);
        }
      } catch (error: any) {
        if (error.response.data.error === "Invalid credentials") {
          const response: any = await getNewToken(userData.token, userData.refresh_token, userData.uuid);

          if (response !== "") {
            userData.token = response.token;
            userData.refresh_token = response.refresh_token;
            updateUser(userData);
            get_vouchers();
          }
        }
      }
    }

    if (init) {
      get_vouchers();
      setInit(false);
    }
  }, [init, updateUser, userData])

  useEffect(() => {
    setUserData(getUser());
  }, [userInfo, getUser])

  const render_vouchers = () => {
    if (voucherList.length === 0) {
      return (
        <div className="w-full">
          <p className="text-sm text-black font-dmsans font-bold">No voucher available.</p>
        </div>
      )
    } else {
      return (
        <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-4">
          {voucherList.map((voucher, index) => {
            let discount = "";
            let min_amount = "";
      
            if (voucher.category === "discount") {
              if (voucher.discount_type === "percent") {
                discount = voucher.discount + "%";
              } else {
                discount = process.env.NEXT_PUBLIC_CURRENCY! + voucher.discount;
              }
            }

            if (voucher.min_amount && voucher.min_amount > 0) {
              min_amount = "Minimum Amount <b>" + process.env.NEXT_PUBLIC_CURRENCY! + voucher.min_amount + "</b>";
            }

            return (
              <div key={index} className="px-6 md:px-8 py-4 border border-[#2C3E2F] border-solid">
                <div className="grid grid-cols-5 items-center mb-4">
                  <div className="col-span-4 text-base font-bold">{voucher.name}</div>
                  <div className="col-span-1 text-right text-2xl font-bold">{discount}</div>
                </div>
                {min_amount.length > 0 && (
                  <ul className="list-disc px-8 mb-4">
                    <li className="text-xs text-[#2C3E2F]" dangerouslySetInnerHTML={{__html: min_amount}}></li>
                  </ul>
                )}
                <hr className="h-[1px] w-full" />
                <div className="grid grid-cols-5 items-center mt-4 gap-2">
                  <div className="col-span-3 md:col-span-4 text-sm text-[#2C3E2F]">Expired date : {voucher.end_date}</div>
                </div>
              </div>
            )
          })}
        </div>
      )
    }
  }

  return (
    <div className="w-full">
      <div className="flex items-center space-x-4">
        <div>
          <Image
            src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icon/user-voucher-icon.png"}
            alt="Account Detail icon"
            width={20}
            height={20}
            quality={100}
            className="hidden md:block"
          />
          <Image
            src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icon/arrow-right.svg"}
            alt="left arrow icon"
            width={24}
            height={24}
            quality={100}
            className="rotate-180 md:hidden"
            onClick={() => props.setSelected("")}
          />
        </div>
        <p className="text-base text-[#2C3E2F] font-dmsans font-bold">My Voucher</p>
      </div>
      <hr className="w-full my-6 h-[1px] bg-[#C6C6C6]" />
      {render_vouchers()}
    </div>
  )
}

export default MyVouchers;
